module.exports = __webpack_public_path__ + "static/media/website.49e43606.md";